import script from "./UiSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiSelect.vue?vue&type=script&setup=true&lang=ts"

import "./UiSelect.vue?vue&type=style&index=0&id=2502b39e&lang=scss"

const __exports__ = script;

export default __exports__